import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment.prod";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { Title, Meta } from "@angular/platform-browser";
import { StaticPagesService } from "./static-pages.service";
// import { environmentVariables } from '../../environments/enviromentalVariables'

@Injectable({
    providedIn: "root",
})
export class MetaService {
    environmentVariables: any;

    constructor(
        private http: HttpClient,
        private title: Title,
        private meta: Meta,
        private confgServ: StaticPagesService
    ) {
        this.getInitilizingData();
    }
    addTag(obj: any) {
        this.meta.addTag(obj);
    }
    updateTag(obj: any) {
        this.meta.updateTag(obj);
    }
    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
        });
    }

    setTitle(titleText: any) {
        this.title.setTitle(titleText);
    }

    setDescription(description: any) {
        this.meta.updateTag({
            name: "description",
            content: 
              `${this.environmentVariables?.metaDescriptionEn ? this.environmentVariables?.metaDescriptionEn   : 
                   `Shop for it at ${this.environmentVariables?.WEBSITE_URL}. Shop Quality with direct Delivery or Pickup. It's now easier than ever to buy  it online from ${this.environmentVariables?.WEBSITE_URL}`}`
            
            ,
        });
        this.meta.updateTag({ name: "twitter:card", content: "summary" });
        this.meta.updateTag({
            name: "twitter:site",
            content: `@${
                this.environmentVariables?.sloganEn ||
                this.environmentVariables?.APP_NAME
            }`,
        });
        this.meta.updateTag({
            name: "twitter:title",
            content: `${
                this.environmentVariables?.sloganEn ||
                this.environmentVariables?.APP_NAME
            }`,
        });
        this.meta.updateTag({
            name: "twitter:description",
            content:
              `${this.environmentVariables?.metaDescriptionEn ? this.environmentVariables?.metaDescriptionEn   : 
                 `Shop for it at ${this.environmentVariables?.WEBSITE_URL}. Shop Quality with direct Delivery or Pickup. It's now easier than ever to buy  it online from ${this.environmentVariables?.WEBSITE_URL}`}`
             ,
        });
        this.meta.updateTag({
            name: "twitter:text:description",
            content:
               `${this.environmentVariables?.metaDescriptionEn ? this.environmentVariables?.metaDescriptionEn   : 
                  `Shop for it at ${this.environmentVariables?.WEBSITE_URL}. Shop Quality with direct Delivery or Pickup. It's now easier than ever to buy  it online from ${this.environmentVariables?.WEBSITE_URL}`}`
             ,
        });
        this.meta.updateTag({
            name: "twitter:image",
            content: this.environmentVariables?.COLORED_LOGO_EN,
        });
        this.meta.updateTag({
            property: "og:url",
            content: this.environmentVariables?.WEBSITE_URL,
        });
        this.meta.updateTag({
            itemprop: "og:title",
            content: `${
                this.environmentVariables?.sloganEn ||
                this.environmentVariables?.APP_NAME
            }`,
        });
        this.meta.updateTag({
            itemprop: "og:description",
            content: 
             `${this.environmentVariables?.metaDescriptionEn ? this.environmentVariables?.metaDescriptionEn   : 
                 `Shop for it at ${this.environmentVariables?.WEBSITE_URL}. Shop Quality with direct Delivery or Pickup. It's now easier than ever to buy  it online from ${this.environmentVariables?.WEBSITE_URL}`}`
            ,
        });
        this.meta.updateTag({
            property: "og:image",
            content: this.environmentVariables?.COLORED_LOGO_EN,
        });
        this.meta.updateTag({
            itemprop: "og:image:secure_url",
            content: this.environmentVariables?.COLORED_LOGO_EN,
        });
        // this.setFbAppId('526389804960003');
    }
    public setFbAppId(appId?: string): void {
        if (Boolean(appId)) {
            this.meta.updateTag({
                property: "fb:app_id",
                content: appId || "",
            });
        } else {
            this.meta.removeTag(`property='fb:app_id'`);
        }
    }
}
